module.exports = __webpack_public_path__ + "static/media/logo-retail24.a62ba3a1.png";